import { useNavigate } from 'react-router-dom'
import { Compass } from 'lucide-react'
import Button from '@/components/button'
import EmptyState from '@/components/empty-state'
import styles from './style.module.css'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className={styles.wrapper}>
      <EmptyState
        icon={<Compass size={28} />}
        title="Página não encontrada"
        description="O endereço acessado não existe no Admin IntegraDoor."
        action={<Button onClick={() => navigate('/')}>Ir para o início</Button>}
      />
    </div>
  )
}

export default NotFound
